// Test component to debug Salt & Stone deodorant scraping
import React, { useState } from 'react';
import { urlScraper } from './lib/urlScraper';

export function TestScrape() {
  const [results, setResults] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  
  const testScrape = async () => {
    setLoading(true);
    const url = 'https://www.saltandstone.com/products/natural-deodorant?variant=43559470006522';
    
    try {
      // First test without AI tags to see raw scraping
      console.log('=== Testing WITHOUT AI tags ===\n');
      // Scrape without AI tags first (no contributionId for test)
      const basicResult = await urlScraper.scrapeProduct(url, undefined, false);
      
      console.log('Title:', basicResult.title);
      console.log('Brand:', basicResult.brand);
      console.log('Category:', basicResult.category);
      console.log('\nDescription (first 1000 chars):');
      console.log(basicResult.description.substring(0, 1000));
      console.log('\nFull Description Length:', basicResult.description.length);
      console.log('\nBasic Tags:', basicResult.tags);
      
      // Now test with AI tags
      console.log('\n\n=== Testing WITH AI tags ===\n');
      // Scrape with AI tags (no contributionId for test)
      const aiResult = await urlScraper.scrapeProduct(url, undefined, true);
      console.log('AI Generated Tags:', aiResult.tags);
      
      // Show the full description to see what's being sent to AI
      console.log('\n\n=== FULL DESCRIPTION BEING SENT TO AI ===\n');
      console.log(basicResult.description);
      
      setResults({
        basic: basicResult,
        ai: aiResult
      });
      
    } catch (error) {
      console.error('Error during scraping:', error);
      setResults({ error: error instanceof Error ? error.message : 'Unknown error' });
    }
    
    setLoading(false);
  };
  
  return (
    <div style={{ padding: '20px' }}>
      <h2>Test Salt & Stone Deodorant Scraping</h2>
      <button onClick={testScrape} disabled={loading}>
        {loading ? 'Testing...' : 'Run Test'}
      </button>
      
      {results && (
        <div style={{ marginTop: '20px' }}>
          <h3>Results (check console for full details)</h3>
          <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto' }}>
            {JSON.stringify(results, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}